<template>
  <v-container>
    <v-row dense>
      <v-col cols="auto">
        <v-card-text>
          <v-text-field :label="text.fields.email" dense v-model="user.email"/>
          <v-text-field
            :label="text.fields.password"
            type="password"
            dense
            v-model="user.password"
          />
        </v-card-text>
      </v-col>
    </v-row>
    <v-row dense justify="center">
      <v-col cols="auto">
        <v-btn small :disabled="!user.email || !user.password"
               @click="login"
        >
          {{ $store.state.text.buttons.login }}
        </v-btn>
        <v-divider dark></v-divider>
      </v-col>
    </v-row>
    <v-row dense justify="center">
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
    </v-row>
    <v-row dense justify="center">
      <v-col cols="auto">
        <v-btn small text color="primary" @click="openRegister">{{
            $store.state.text.buttons.register
          }}
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { translations } from '@/lang/translations';
import Axios from '@/core/Axios';
import router from '@/router';
import store from '@/store';

export default {
  name: 'UserLoginForm',
  data() {
    return {
      axios: new Axios(),
      user: {
        email: null,
        password: null,
      },
    };
  },
  computed: {
    text() {
      return translations[this.$store.state.language];
    },
  },
  methods: {
    openRegister() {
      this.$store.commit('setShowMobileMenu', false);
      router.push({ path: '/register' });
    },
    login() {
      this.axios.makeCall('POST', 'norbit/customer/login', this.user)
        .then((response) => {
          this.$store.commit('loginUser', {
            uid: response.customer.uid,
            username: response.customer.username,
            token: response.token,
          });
        })
        .catch((error) => {
          this.$store.dispatch('showSnackBar', {
            type: 'error',
            message:
              this.text.messages[error],
          });
        });
    },
  },
};
</script>

<style scoped>

</style>
